import Vue from 'vue';
import App from './App.vue';
import router from './router'; // 引入路由配置
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 样式文件
// import 'layui-src/dist/css/layui.css'; // 引入 Layui CSS
// import layui from 'layui-src'; // 引入 Layui JS
import '@fortawesome/fontawesome-free/css/all.css'; // 确保引入了所有需要的样式
// window.layui = layui; // 将 layui 添加到全局

Vue.use(ElementUI);
Vue.config.productionTip = false;

import { sayHello, setWithExpiry ,getWithExpiry, getWithExpiryTime} from './utils/globalFunctions';
Vue.prototype.$sayHello = sayHello;
Vue.prototype.$setWithExpiry = setWithExpiry;
Vue.prototype.$getWithExpiry = getWithExpiry;
Vue.prototype.$getWithExpiryTime = getWithExpiryTime;

new Vue({
  router, // 将路由注入到 Vue 实例
  render: h => h(App),
}).$mount('#app');

// 路由拦截器
// router.beforeEach((to, from, next) => {
//   if (to.matched.length != 0) {
//       if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
//           if ((localStorage.getItem("userInfo"))) { // 通过vuex state获取当前的user是否存在
//               next();
//           } else {
//               next({
//                   path: '/user/login',
//                   query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
//               })
//           }
//       } else {
//           if ((localStorage.getItem("userInfo"))) { // 判断是否登录
//               if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
//                   next();
//               } else {
//                   /**
//                    * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
//                    */
//                   next({
//                       path: '/admin/mailTask'
//                   })
//               }
//           } else {
//               next();
//           }
//       }
//   } else {
//       next({
//           path: '/login',
//           query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
//       })
//   }
// })